import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const KarbonIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.86001 3.76001C5.43001 3.76001 5.07001 4.11001 5.07001 4.55001V19.45C5.07001 19.89 5.42001 20.24 5.86001 20.24C6.30001 20.24 6.65001 19.89 6.65001 19.45V4.55001C6.65001 4.11001 6.30001 3.76001 5.86001 3.76001Z",
                fill: "#1D1D1D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.71999 9.17999C2.28999 9.17999 1.92999 9.52999 1.92999 9.96999V14.03C1.92999 14.47 2.27999 14.82 2.71999 14.82C3.15999 14.82 3.50999 14.47 3.50999 14.03V9.96999C3.50999 9.52999 3.15999 9.17999 2.71999 9.17999Z",
                fill: "#1D1D1D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.00997 1.95001C8.57997 1.95001 8.21997 2.30001 8.21997 2.74001V21.25C8.21997 21.69 8.56997 22.04 9.00997 22.04C9.44997 22.04 9.79997 21.69 9.79997 21.25V2.74001C9.79997 2.30001 9.44997 1.95001 9.00997 1.95001Z",
                fill: "#1D1D1D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.84 15.13L18.73 12L21.83 8.89C22.14 8.58 22.14 8.08 21.83 7.77C21.52 7.46 21.03 7.46 20.72 7.77L12.95 15.59V13.29L20.15 6.07C20.46 5.76 20.46 5.26 20.15 4.95C19.85 4.64 19.35 4.64 19.04 4.95L12.94 11.06V8.89L17.71 4.09C18.02 3.78 18.02 3.28 17.71 2.97C17.4 2.66 16.91 2.66 16.6 2.97L12.94 6.65V2.29C12.94 1.85 12.59 1.5 12.15 1.5C11.71 1.5 11.36 1.85 11.36 2.29V21.71C11.36 22.15 11.71 22.5 12.15 22.5C12.59 22.5 12.94 22.15 12.94 21.71V17.9L16.25 21.23C16.55 21.54 17.05 21.54 17.36 21.23C17.67 20.92 17.67 20.42 17.36 20.11L14.01 16.74L15.26 15.49L18.92 19.17C19.22 19.48 19.72 19.48 20.03 19.17C20.34 18.85 20.34 18.36 20.03 18.05L16.37 14.37L17.62 13.12L20.74 16.25C21.04 16.56 21.54 16.56 21.85 16.25C22.16 15.94 22.16 15.44 21.85 15.13H21.84Z",
                fill: "#1D1D1D"
            })
        ]
    });
};
